<template>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title" id="exampleModalLabel">Order Reciept</h3>
                <button type="button" ref="close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"  @click="handleClose">
                </button>
            </div>
            <div class="modal-body">
                    <div class="card">
  <div class="card-body mx-4">
        <div class="container">
        <p class="my-4" style="font-size: 30px;">Checkout Order<span v-if="tableName"> - {{ tableName }}</span></p>
        <div class="row">
            <ul class="list-unstyled">
            <li class="text-muted mt-1 h4"><span class="text-black h4">Invoice:</span> {{order.readable_ID}}</li>
            </ul>
            <hr>
          
    <div class="row" v-for="(item, index) in visibleItems" :key="index">
            <div :class="updateOrder ? 'col-8' : 'col-9'">
            <p>{{item.numberOfDrinks + ' x ' + item.name}} <span style="color: grey;">{{ ' ($' + item.cost_with_tax.toFixed(2) + ')' }}</span></p>
             <p v-if="item.specialInstructions" class="ms-4"><b>Special Instructions: </b></p>
             <p v-if="item.specialInstructions" class="ms-4">{{item.specialInstructions}}</p>
              <div v-if="item.additionalInfo" class="ms-4">
                <p><b>Additional Info: </b></p>
                <div 
                  v-for="(info, key) in item.additionalInfo" 
                  :key="key" 
                  class="additional-info margin-xl-left-header"
                >
                  <p 
                    v-for="(dataItem, subKey) in info" 
                    :key="subKey" 
                    class="additional-item-text"
                  >
                    <span class="bold-text">{{ subKey }}</span> - ${{ parseFloat(dataItem.cost).toFixed(2) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-3">
              <p class="float-end">$ {{ getFullItemCost(item).toFixed(2) }}</p>
            </div>
             <div class="col-1 d-flex align-items-start">
              <button
                v-if="updateOrder"
                class="btn btn-sm btn-danger my-1"
                @click="removeItem(item.item_ID)"
                style="font-size: 1.25rem; font-weight: bold;"
              >
                X
              </button>
            </div>
            <hr v-if="index!=$props.order.item_list.length-1">
        </div>
       

            <hr style="border: 2px solid black;">
        </div>
        <div class="row text-black">

          <div class="col-xl-12">
            <p class="float-end ">Sub Total: ${{getSubTotal().toFixed(2)}}
            </p>
            </div>

            <div v-if="$props.order.payment_ID" class="col-xl-12">
            <p class="float-end ">Platform Fee: $ {{platformFee(order.total_cost)}}
            </p>
            </div>

            <div v-if="$props.order.stripe_tip_amount" class="col-xl-12">
            <p class="float-end ">Tip: $ {{toDollarAmount(order.stripe_tip_amount)}}
            </p>
            </div>

            <div class="col-xl-12">
            <p class="float-end fw-bold">Total: $ {{toDollarAmount(order.total_cost)}}
            </p>
            </div>
            <hr style="border: 2px solid black;">
        </div>


        </div>
        <h4>Notes</h4>
        <textarea v-model="notes" placeholder="Add a note to share with the customer. Use this for cancellation reasons or brief order updates with pings."></textarea>
    </div>

</div>

            </div>
            
            
            <div v-if="updateOrder" class="modal-footer">
        <button type="button" class="btn btn-secondary"  v-on:click="toggleUpdateOrder">Cancel Modify</button>
        <button type="button" class="btn btn-primary" v-on:click="acceptModifiedOrder">Accept Modified Order</button>
      </div>
            <div v-else-if="!$props.order.is_accepted" class="modal-footer">
        <button v-if="$props.order.location_ID === 'fastest'" type="button" class="btn btn-secondary"  v-on:click="declineOrder">Decline Order</button>
        <button v-else type="button" class="btn btn-secondary"  v-on:click="newCancel">Cancel Order</button>
        <button type="button" class="btn btn-secondary"  v-on:click="toggleUpdateOrder">Modify Order</button>
        <button type="button" class="btn btn-primary" v-on:click="acceptOrder">Accept Order</button>
      </div>
      <div v-if="$props.order.is_accepted && !updateOrder" class="modal-footer">
        <button type="button" class="btn btn-secondary"  v-on:click="pingOrder">Ping Order</button>
        <button type="button" class="btn btn-secondary"  v-on:click="newCancel">Cancel Order</button>
        <button type="button" class="btn btn-secondary"  v-on:click="toggleUpdateOrder">Modify Order</button>
        <button type="button" class="btn btn-primary" v-on:click="completeOrder">Complete Order</button>
      </div>
        </div>
    </div>
</template>

<script>

import swal from 'sweetalert';
import swal2 from 'sweetalert2';

export default {
  name: 'CheckoutOrder',
  props: ['order','bar_id','tableName'],
  data() {
    return {
     notes:"",
     updateOrder:false,
     updatedOrderList:[]
    };
  },
  computed:{
     visibleItems() {
        const items = this.updateOrder
          ? this.updatedOrderList
          : this.$props.order?.item_list;

        if (!Array.isArray(items)) return [];

        return items.filter(i => !i.removed);
      }
  },
  methods: {
    handleClose(){
      this.notes = ''; // or any other data mutation
      this.updateOrder = false;
    },
    removeItem(id) {
       const index = this.updatedOrderList.findIndex(item => item.item_ID === id);
        if (index !== -1) {
          this.$set(this.updatedOrderList[index], 'removed', true);
        }
    },
    toggleUpdateOrder() {
      this.updateOrder = !this.updateOrder;
      if (this.updateOrder) {
        // Just copy the item list, not the whole order
        this.updatedOrderList = JSON.parse(JSON.stringify(this.$props.order.item_list));
      } else {
        this.updatedOrderList = [];
      }
    },


    platformFee(){
      var subtotal = this.getSubTotal()
      const subInPennies = subtotal*100
            const platformFee = Math.round(subInPennies * 0.031+20); // 3.1% +20c
              const stripeFee = Math.round(subInPennies * 0.029 + 30); //2.9%+30c
            const serviceChargeValue = (stripeFee+platformFee)*.01
      return serviceChargeValue.toFixed(2)
    },

    getSubTotal() {
      if (!this.$props.order || !Array.isArray(this.$props.order.item_list)) return 0;

      return this.$props.order.item_list.reduce((acc, item) => {
        if (item.removed) return acc;
        return acc + this.getFullItemCost(item);
      }, 0);
    },
    getFullItemCost(menuItem){
      var totalCost = menuItem.cost_with_tax*menuItem.numberOfDrinks;
        // Iterate through the main object
      for (let key in menuItem.additionalInfo) {
        // Iterate through the nested objects (items like bacon, rice, etc.)
        for (let additonalInfoItem in menuItem.additionalInfo[key]) {
          // Add the cost to the total, converting the cost string to a number
          totalCost += parseFloat(menuItem.additionalInfo[key][additonalInfoItem].cost);
        }
      }
      console.log("additional cost: ",totalCost)
      return totalCost
    },
    toDollarAmount(value){
      return (value*.01).toFixed(2)
    },
    acceptModifiedOrder(){
      const allRemoved = this.updatedOrderList.length > 0 &&
                   this.updatedOrderList.every(item => item.removed === true);
      if(!allRemoved){
        swal({
  title: 'Are you sure you want to accept this modified order.',
  text: "This will alert the customer to pick up the remaining items. This action can't be undone",
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  closeOnClickOutside: false,
})
  .then((value) => {
      if(value){
       const modifiedOrder = JSON.parse(JSON.stringify(this.$props.order)); // deep clone original
        modifiedOrder.item_list = this.updatedOrderList; // replace item list
        modifiedOrder.acceptance_notes = this.notes;

        if (modifiedOrder.location_ID === 'fastest') {
          modifiedOrder.location_ID = this.$props.bar_id;
        }

        this.updateOrder=false;
        this.$emit("acceptModifiedOrder", modifiedOrder);
        this.$refs.close.click();
        this.notes= ''
      }
      });
      }
      else{
        this.cancelOrder()
      }
          
    },
    acceptOrder() {
          swal({
  title: 'Are you sure you want to accept this order.',
  text: 'This will alert customer to come for pick up',
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  closeOnClickOutside: false,
})
  .then((value) => {
      if(value){
        this.$props.order.acceptance_notes = this.notes
        if(this.$props.order.location_ID=='fastest'){
          this.$props.order.location_ID = this.$props.bar_id
        }
          this.$emit("acceptOrder",this.$props.order)
          this.$refs.close.click();
          this.notes= ''
      }
      });
    },
    newCancel() {
      swal2.fire({
        title: 'Are you sure you want to cancel this order?',
        html: `
          <label for="cancelReason" class="mb-2">Select a reason (optional):</label>
          <select id="cancelReason" class="swal2-select">
            <option value="">-- No Reason --</option>
            <option>Out of stock</option>
            <option>Venue is closing</option>
            <option>Customer not present</option>
            <option>Payment Failed</option>
          </select>
        `,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        preConfirm: () => {
          const selected = document.getElementById('cancelReason').value;
          return selected || null; // Optional reason
        }
      }).then((result) => {
        if (result.isConfirmed) {
          const reason = result.value; // May be null or string
           this.$props.order.cancel_reason = reason
           this.$props.order.update_ID = this.$props.order.device_ID

          this.$emit("cancelOrder",this.$props.order)
          this.$refs.close.click();
          this.notes= ''
        }
      });
    },
    declineOrder(){   
      swal({
  title: 'Are you sure you want to Decline this order?',
  text: "Other locations will still be able to accept ",
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  closeOnClickOutside: false,
})
  .then((value) => {
      if(value){
        this.$props.order.cancel_reason = this.notes
        this.$props.order.update_ID = this.$props.order.device_ID
        const barID = this.$props.bar_id
        const orderID = this.$props.order._id

          this.$emit("declineOrder",{barID,orderID})
          this.$refs.close.click();
          this.notes= ''
      }
    });
  },
    cancelOrder(){   
    const defaultString =  "Sorry about that!";   
      swal({
  title: 'Are you sure you want to remove this order? Send the following:',
  text: "Order has been cancelled. "+ (this.notes.trim() === ''? defaultString :this.notes),
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  closeOnClickOutside: false,
})
  .then((value) => {
      if(value){
        this.$props.order.cancel_reason = this.notes
        this.$props.order.update_ID = this.$props.order.device_ID

          this.$emit("cancelOrder",this.$props.order)
          this.$refs.close.click();
          this.notes= ''
      }
    });
  },
  pingOrder(){  
       const defaultString = !this.$props.order.isTableOrder? "Your order is ready for pickup. Please arrive soon to avoid cancellation." : "Please ensure you are at your table.";
      swal({
  title: 'Are you sure you want to ping this order? Send the following:',
  text: this.notes.trim() === ''? defaultString :this.notes,
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  closeOnClickOutside: false,
})
  .then((value) => {
      if(value){
        this.$props.order.ping_notes = this.notes
        this.$props.order.update_ID = this.$props.order.device_ID

          this.$emit("pingOrder",this.$props.order)
          this.$refs.close.click();
          this.notes= ''
      }
    });
  },
  completeOrder(){
    this.$emit('completeOrder',this.$props.order)
     this.$refs.close.click();
  }
  },
};
</script>

<style>
/* styles here */
</style>
